import {ActionContext } from "vuex";
import ListModule from "../list-module";
import ListState from "../list-state";
import Ajax from "../../../lib/ajax";
import PageResult from "@/store/entities/page-result";
import OfferTimeSlot from "../../entities/booking/offerTimeSlot";

interface OfferTimeSlotState extends ListState<OfferTimeSlot> {
  fristTime: OfferTimeSlot;
  editOfferTimeSlot: OfferTimeSlot;
}
class OfferTimeSlotModule extends ListModule<OfferTimeSlotState, any, OfferTimeSlot> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<OfferTimeSlot>(),
    loading: false,
    editOfferTimeSlot: new OfferTimeSlot(),
  };
  actions = {
    async getAll(context: ActionContext<OfferTimeSlotState, any>, payload: any) {
      context.state.loading = true;
      let reponse = await Ajax.get("/api/services/app/OfferTimeSlot/GetAll", {
        params: payload.data,
      });
      context.state.loading = false;
      let page = reponse.data.result as PageResult<OfferTimeSlot>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async create(context: ActionContext<OfferTimeSlotState, any>, payload: any) {
     return Ajax.post("/api/services/app/OfferTimeSlot/Create", payload.data);
    },
    async update(context: ActionContext<OfferTimeSlotState, any>, payload: any) {
      await Ajax.put("/api/services/app/OfferTimeSlot/Update", payload.data);
    },
    async updateWithImages(
      context: ActionContext<OfferTimeSlotState, any>,
      payload: any
    ) {
      await Ajax.put("/api/services/app/OfferTimeSlot/UpdateWithImages", payload.data);
    },
    async delete(context: ActionContext<OfferTimeSlotState, any>, payload: any) {
      context.state.loading = true;
      await Ajax.delete(
        "/api/services/app/OfferTimeSlot/Delete?Id=" + payload.data.id
      );
      context.state.loading = false;
    },
    async get(context: ActionContext<OfferTimeSlotState, any>, payload: any) {
      let reponse = await Ajax.get(
        "/api/services/app/OfferTimeSlot/Get?Id=" + payload.id
      );
      return reponse.data.result as OfferTimeSlot;
    },
    async CreateCourtOfferTimeSlotForAllUsers(
      context: ActionContext<OfferTimeSlotState, any>,
      payload: any
    ) {
      console.log(payload.data, "datadata");
      let reponse = Ajax.post(
        "/api/services/app/OfferTimeSlot/CreateCourtOfferTimeSlotForAllUsers",
        payload.data
      );
      return reponse;
    },
  };
  mutations = {
    setCurrentPage(state: OfferTimeSlotState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: OfferTimeSlotState, pagesize: number) {
      state.pageSize = pagesize;
    },
    edit(state: OfferTimeSlotState, offerTimeSlot: OfferTimeSlot) {
      state.editOfferTimeSlot = offerTimeSlot;
    },
    setList(state: OfferTimeSlotState){
      state.list = [];
    },
    changeLoading(state: OfferTimeSlotState, pass: boolean) {
      state.loading = pass;
    },
  };
}
const offerTimeSlotModule = new OfferTimeSlotModule();
export default offerTimeSlotModule;
